module.exports = __webpack_public_path__ + "static/media/logo-color.e6dfbfe0.svg";